module.exports = __webpack_public_path__ + "static/media/char_children.d4825884.png";